<template>
  <div id="202301" class="202301 main-text-color">
    <header class="justify-center hidden lg:flex">
      <a class="inline-flex p-4 py-10 cursor-pointer" @click="toTop('#banner')"><img src="~@/assets/images/202301/flower.png" class="object-contain mr-2">開學好禮大方送</a>
      <a class="inline-flex p-4 py-10 cursor-pointer" @click="toTop('#magazine')"><img src="~@/assets/images/202301/flower.png" class="object-contain mr-2">英日語雜誌訂閱</a>
      <a class="inline-flex p-4 py-10 cursor-pointer" @click="toTop('#hiw')"><img src="~@/assets/images/202301/flower.png" class="object-contain mr-2">知識大圖解訂閱</a>
      <a class="inline-flex p-4 py-10 cursor-pointer" @click="toTop('#books')"><img src="~@/assets/images/202301/flower.png" class="object-contain mr-2">暢銷叢書任你選</a>
      <a class="inline-flex p-4 py-10 cursor-pointer" @click="toTop('#talk')"><img src="~@/assets/images/202301/flower.png" class="object-contain mr-2">訂雜誌抽旅人包</a>
    </header>
    <nav class="topNav lg:hidden justify-between z-50">
      <button class="ham" @click="isOpen=!isOpen">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
      <div class="px-3 md:px-4">
        <img src="~@/assets/images/202301/LiveABC-logo.png" class="object-contain w-full">
      </div>
    </nav>
    <nav class="sideNav z-50" :class="{ showNav: isOpen }">
      <button class="menuX" @click="isOpen = false">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      <ul>
        <li><a class="menuLink" @click="toTopM('#banner')"><font-awesome-icon icon="chevron-right" class="text-white mr-4 icon" />開學好禮大方送</a></li>
        <li><a class="menuLink" @click="toTopM('#magazine')"><font-awesome-icon icon="chevron-right" class="text-white mr-4 icon" />英日語雜誌訂閱</a></li>
        <li><a class="menuLink" @click="toTopM('#hiw')"><font-awesome-icon icon="chevron-right" class="text-white mr-4 icon" />知識大圖解訂閱</a></li>
        <li><a class="menuLink" @click="toTopM('#books')"><font-awesome-icon icon="chevron-right" class="text-white mr-4 icon" />暢銷叢書任你選</a></li>
        <li><a class="menuLink" @click="toTopM('#talk')"><font-awesome-icon icon="chevron-right" class="text-white mr-4 icon" />訂雜誌抽旅人包</a></li>
      </ul>
    </nav>
    <div class="banner w-full" id="banner">
      <div class="max-w-xs md:max-w-xl lg:max-w-6xl mx-auto px-4 py-24 lg:py-8 flex justify-center">
        <div class=" z-10">
          <img src="~@/assets/images/202301/master-img.png" class="object-contain">
        </div>
      </div>

      <div class="banner-bg relative">
        <div class="container max-w-6xl mx-auto px-4 py-32 lg:py-8 flex justify-center">
          <div class="z-10 hidden lg:block">
            <img src="~@/assets/images/202301/gift.png" class="object-contain">
          </div>
        </div>
        <div class="absolute leafL">
          <img src="~@/assets/images/202301/leaf-L.svg" class="object-contain">
        </div>
        <div class="absolute leafR">
          <img src="~@/assets/images/202301/leaf-R.svg" class="object-contain">
        </div>

        <div class="absolute cloud">
          <img src="~@/assets/images/202301/cloud.png" class="object-contain">
        </div>
      </div>

      <div class="lg:hidden w-full py-10">
        <img src="~@/assets/images/202301/gift-m.png" class="object-contain mx-auto">
      </div>

    </div>

    <main class="green-bg">
      <section class="section1 py-8 lg:py-4">
        <div class="container max-w-6xl mx-auto px-4 flex justify-center">
          <img src="~@/assets/images/202301/order-info.png" class="object-contain z-20 hidden md:block">
          <img src="~@/assets/images/202301/order-info-m.png" class="object-contain z-20 md:hidden">
        </div>
      </section>

      <section class="text-center leading-loose py-4 pb-8 text-shadow main-text-color tracking-wider px-4">
        <h6 class="text-2xl lg:text-3xl mb-2 font-semibold">LiveABC春季開學書展滿額贈＆抽獎活動辦法</h6>
        <p class="lg:text-lg font-semibold">2023.2.1~2023.3.31於LiveABC官方網站購買商品，訂單成立後（需付款完成）即可參加下列活動</p>
        <p class="lg:text-lg">1.「滿額$2500送How It Works知識大圖解 太空奧祕大圖解(精裝本)」，單筆訂單贈送乙本，不累送。</p>
        <p class="lg:text-lg">2.「滿額$2500抽MOLESKINE NOMAD後背包-黑色(市價3790元)」，共抽出4名<br/>將於2023/4月底前抽出中獎者，並公告於LiveABC官方網站及官方臉書粉絲團。</p>
      </section>

      <section class="container max-w-6xl mx-auto px-3">
        <div class="mb-10" id="magazine">
          <img src="~@/assets/images/202301/title-5mg.png" class="object-contain z-20 w-full hidden lg:block">
          <img src="~@/assets/images/202301/title-5mg-m.png" class="object-contain z-20 w-full lg:hidden">
        </div>
        <div class="magazine bg-white rounded-3xl border-main2 border px-4 mb-12 lg:mb-16">
          <div class="mb-4 border-b-4 border-main p-4">
            <img src="~@/assets/images/202301/MG-price.png" class="object-contain z-20 hidden md:block">
            <img src="~@/assets/images/202301/MG-price-m.png" class="object-contain z-20 md:hidden">
          </div>

          <div class="flex flex-wrap">
            <router-link :to="{ name: 'detail', params: { category: 'magazine', id: item.id } }" class="item w-1/2 lg:w-1/5 p-2 md:p-3 cursor-pointer" v-for="(item, idx) in planData" :key="idx">

              <div class="bg-white rounded-lg h-full flex flex-col justify-between" v-if="renderComponent">
                <div class="item relative">
                  <div class="outer mb-2">
                    <div class="inner mx-auto border-0 absolute w-full h-full">
                      <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block"  v-if="!item.cover">
                      <img v-lazy="`https://api.liveabc.com/v1/product_categories/${item.category_id}/cover`" class="w-full h-full object-contain block" v-else>
                    </div>
                  </div>
                </div>

                <div class="mag-title mt-5 flex flex-col justify-center items-center">
                  <div class="mb-3">
                    <img :src="item.logo_url" alt="livaABC" class="w-full h-auto object-contain block">
                  </div>
                </div>

                <div class="border-b-2 my-4"></div>

                <div class="price event_text px-3 text-center tracking-wider">
                  <p class="font-bold mb-1">{{ item.category_name }} 10期＋<br/>LiveABC智慧點讀筆（無藍牙）</p>
                  <p class="mb-1 text-sm text-gray-500">(送1.2月典藏雜誌)</p>
                  <p class="text-lg font-semibold mb-4">特價 $<span class="text-red-500">2990</span> 元</p>
                  <div class="flex flex-wrap justify-center items-center">
                    <a href="https://store.liveabc.com/products/package/sale?tag=196" class="but-btn px-4 py-2">
                      <img src="~@/assets/images/202301/sub_btn.png" alt="livaABC">
                    </a>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>

        <div class="mb-10" id="hiw">
          <img src="~@/assets/images/202301/title-HIWmg.png" class="object-contain z-20 w-full hidden lg:block">
          <img src="~@/assets/images/202301/title-HIWmg-m.png" class="object-contain z-20 w-full lg:hidden">
        </div>
        <div class="hiw bg-white box-shadow border-main2 border p-6 mb-12 lg:mb-16">
          <a class="flex flex-col md:flex-row items-center lg:items-end" href="https://store.liveabc.com/magazine/detail/8289" target="_blank">
            <div class="p-4 md:hidden"><img src="~@/assets/images/202301/HIW-PRICE-1-m.png" class="object-contain z-20"></div>
            <div class="p-4"><img src="~@/assets/images/202301/hiw.png" class="object-contain z-20"></div>
            <div class="px-4 hidden md:block"><img src="~@/assets/images/202301/HIW-PRICE.png" class="object-contain z-20"></div>
            <div class="p-4 pb-0 md:hidden"><img src="~@/assets/images/202301/HIW-PRICE-2-m.png" class="object-contain z-20"></div>
            <div class="p-4 pt-0 md:hidden"><img src="~@/assets/images/202301/197.png" class="object-contain z-20"></div>
            <div class="p-4 pt-0 hidden md:flex items-end h-full stretch"><img src="~@/assets/images/202301/sub_btn.png" class="h-full object-contain z-20"></div>
          </a>
        </div>

        <div class="mb-10" id="books">
          <img src="~@/assets/images/202301/title-books.png" class="object-contain z-20 w-full hidden lg:block">
          <img src="~@/assets/images/202301/title-books-m.png" class="object-contain z-20 w-full lg:hidden">
          </div>

        <a href="" class="flex items-center mx-auto justify-center mb-10 px-2 lg:px-0">
          <p class="text-shadow mr-3 text-sm lg:text-lg font-medium whitespace-no-wrap">更多叢書選擇請至官網選購</p>
          <div><img src="~@/assets/images/202301/web_btn.png" class="object-contain z-20"></div>
        </a>

        <div class="books bg-white box-shadow border-main2 border mb-12 lg:mb-16 overflow-hidden">

          <div class="flex flex-wrap">
            <router-link :to="{ name: 'detail', params: { category: 'magazine', id: item.id } }" class="item w-1/2 lg:w-1/4 p-2 md:p-4 cursor-pointer border-4 border-main" v-for="(item, idx) in bookData" :key="idx">

              <div class="bg-white rounded-lg h-full flex flex-col justify-between" v-if="renderComponent">
                <div class="item relative">
                  <div class="outer mb-2">
                    <div class="inner mx-auto border-0 absolute w-full h-full">
                      <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!item.cover">
                      <img v-lazy="item.cover" class="w-full h-full object-contain block" v-else>
                    </div>
                  </div>
                </div>

                <!-- <div class="mag-title mt-5 flex flex-col justify-center items-center">
                  <div class="mb-3">
                    <img :src="item.logo_url" alt="livaABC" class="w-full h-auto object-contain block">
                  </div>
                </div> -->

                <div class="price event_text px-3 text-center tracking-wider">
                  <p class="text-lg font-black mb-2">{{ item.text }}</p>
                  <p>{{ item.name }}</p>
                </div>
              </div>
            </router-link>
          </div>
        </div>

        <div class="mb-10" id="talk">
          <img src="~@/assets/images/202301/title-live-talk.png" class="object-contain z-20 w-full hidden lg:block">
          <img src="~@/assets/images/202301/title-live-talk-m.png" class="object-contain z-20 w-full lg:hidden">
        </div>
        <div class="talk mb-12 lg:mb-16">
          <div class="flex flex-wrap">
            <router-link :to="{ name: 'detail', params: { category: 'magazine', id: item.id } }" class="item w-full lg:w-1/2 p-2 md:p-4 cursor-pointer" v-for="(item, idx) in talkData" :key="idx">

              <div class="h-full flex flex-col justify-between mb-3 bg-white border-main2 border box-shadow p-4 lg:p-10">
                <div class="text-2xl font-bold tracking-wider text-center leading-relaxed mb-3">
                  <p class="whitespace-pre-wrap">{{ item.name }}</p>
                </div>

                <div class="flex justify-center mb-3">
                  <div><img src="~@/assets/images/202301/livetalk.png" class="object-contain inline-block"></div>
                  <div class="mt-4 -ml-4">
                    <img :src="item.logo_url" class="w-full h-full object-contain block">
                  </div>
                </div>

                <div class="flex items-end justify-between lg:px-8 font-semibold">
                  <div class="w-4/5 lg:w-auto">
                    <p class="text-sm lg:text-lg">原價7188元</p>
                    <p class="text-xl lg:text-3xl whitespace-no-wrap">特價$<span class="text-red-500">4590</span>元</p>
                  </div>
                  <a href="https://store.liveabc.com/products/package/sale?tag=196" class="but-btn px-4 py-2 inline-block">
                    <img src="~@/assets/images/202301/sub_btn.png" alt="livaABC">
                  </a>
                </div>
              </div>
            </router-link>
          </div>
        </div>

        <div class="mb-10">
          <img src="~@/assets/images/202301/title-oldmg.png" class="object-contain z-20 w-full hidden lg:block">
          <img src="~@/assets/images/202301/title-oldmg-m.png" class="object-contain z-20 w-full lg:hidden">
        </div>
        <div class="collection bg-white box-shadow border-main2 border mb-12 lg:mb-16">

          <div class="flex flex-wrap">
            <router-link :to="{ name: 'detail', params: { category: 'magazine', id: item.id } }" class="item w-1/2 lg:w-1/4 p-2 md:p-4 cursor-pointer border-4 border-main" v-for="(item, idx) in collectionData" :key="idx">

              <div class="bg-white rounded-lg h-full flex flex-col justify-between" v-if="renderComponent">
                <div class="item relative">
                  <div class="outer mb-2">
                    <div class="inner mx-auto border-0 absolute w-full h-full">
                      <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block"  v-if="!item.cover">
                      <img v-lazy="item.cover" class="w-full h-full object-contain block" v-else>
                    </div>
                  </div>
                </div>

                <!-- <div class="mag-title mt-5 flex flex-col justify-center items-center">
                  <div class="mb-3">
                    <img :src="item.logo_url" alt="livaABC" class="w-full h-auto object-contain block">
                  </div>
                </div> -->

                <div class="price event_text px-3 text-center tracking-wider">
                  <p class="font-black mb-2">{{ item.category_name }}</p>
                  <p>{{ item.name }}</p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </section>

      <section class="event_text py-6 pb-10 main-text-color text-shadow">
        <div class="container max-w-6xl mx-auto font-semibold px-4 pl-8">
          <h6 class="text-xl lg:text-2xl mb-4">注意事項</h6>
          <ul class="list-decimal list-outside leading-loose text-base">
            <li>活動期間產生之訂單取消、退貨、交易失敗等條件，將失去參與本活動之資格，不予另行通知。</li>
            <li>中華民國稅法規定，中獎贈品或獎金價值超過市價新台幣1,000元，年度報稅時須計入個人所得，故中獎人於領獎後、所得稅徵收前，將會收到本公司所發出之扣繳憑證。</li>
            <li>本活動之抽獎贈品不得轉換、轉讓他人。</li>
            <li>如提供獎項因故無法取得，本公司保留替換其他等值獎項及變更、修改本活動之權利，並將最新變更後內容公布於官網活動頁面，不再個別提醒/通知客戶本活動內容之變更。</li>
            <li>詳細活動內容以LiveABC官網發布為主。本公司保留活動修改、變更之權利。</li>
          </ul>
        </div>
      </section>
    </main>

    <footer class="bg-white py-8">
      <p class="text-center text-gray-300 font-semibold text-xs lg:text-sm px-2">Copyright © 2022 Hebron Soft Limited All Rights Reserved.</p>
    </footer>
  </div>
</template>
<script>
import jump from 'jump.js'
import axios from 'axios'
export default {
  name: 'Jan2023',
  metaInfo () {
    return {
      title: 'LiveABC春季開學書展｜消費抽實用旅人包',
      titleTemplate: null
    }
  },
  components: {
  },
  data () {
    return {
      isOpen: false,
      renderComponent: false,
      planData: [
        { id: 8398, type: 'abc', introduction: '初級/基礎/活用', text: '打好英語基礎的最佳選擇！', logo_url: require('@/assets/images/202301/abc.png') },
        { id: 8399, type: 'live', introduction: '中級/生活/實用', text: '日常生活實用英語輕鬆學！', logo_url: require('@/assets/images/202301/live.png') },
        { id: 8400, type: 'all', introduction: '中高級/進階/應用', text: '閱讀寫作訓練豐富又多元！', logo_url: require('@/assets/images/202301/ALL.png') },
        { id: 8401, type: 'cnn', introduction: '新聞/時事/新知', text: '托福、多益檢測超必備！', logo_url: require('@/assets/images/202301/CNN.png') },
        { id: 8402, type: 'jp', introduction: '初級/生活/實用', text: '自學日語最佳輔助教材！', logo_url: require('@/assets/images/202301/JAPAN.png') }
        // { id: 7340, type: 'hiw', introduction: '圖解/百科/符合108課綱', text: '團購秒殺搶購，佳評如潮！', logo_url: require('@/assets/images/20221202/HIW.png') }
      ],
      hiwData: [
        { id: 7340, type: 'hiw', introduction: '圖解/百科/符合108課綱', text: '團購秒殺搶購，佳評如潮！' }
      ],
      bookData: [
        { id: 7986, text: '專為準備大學學測考試的你而設計！' },
        { id: 7964, text: '戰勝國中教育會考英語一本就夠' },
        { id: 7873, text: 'GEPT初級檢測要過關，掌握基本單字最關鍵' },
        { id: 7104, text: '增加實戰經驗的練習寶典' },
        { id: 7399, text: '多益TOEIC最強三大觀念起手！金色證書就這樣準備' },
        { id: 6869, text: '快速掌握雅思高分技巧' },
        { id: 7801, text: '生活裡臨時想用卻不知道怎麼說的字都在這裡' },
        { id: 6051, text: '獨家歸納聯想學習法，輕鬆記單字' },
        { id: 7287, text: '從發音開始學起，紮好基礎學好法語法' },
        { id: 7648, text: '最符合108課綱的小學生英語教材' },
        { id: 7946, text: '用英文認識新朋友和傳福音' },
        { id: 7560, text: '68篇實用範例，寫出語法正確、句意清楚的商務信件' }
      ],
      talkData: [
        { id: 7296, logo_url: require('@/assets/images/202301/abc1.png') },
        { id: 7309, logo_url: require('@/assets/images/202301/live1.png') }
      ],
      collectionData: [
        { id: 7564, text: '專為準備大學學測考試的你而設計！' },
        { id: 7683, text: '戰勝國中教育會考英語一本就夠' },
        { id: 7984, text: 'GEPT初級檢測要過關，掌握基本單字最關鍵' },
        { id: 7958, text: '增加實戰經驗的練習寶典' },
        { id: 7962, text: '多益TOEIC最強三大觀念起手！金色證書就這樣準備' },
        { id: 8005, text: '快速掌握雅思高分技巧' },
        { id: 7881, text: '生活裡臨時想用卻不知道怎麼說的字都在這裡' },
        { id: 7570, text: '獨家歸納聯想學習法，輕鬆記單字' }
      ]
    }
  },
  mounted () {
    this.getEvent()
  },
  methods: {
    async getEvent () {
      let self = this
      await self.getData(self.planData)
      await self.getData(self.hiwData)
      await self.getData(self.bookData)
      await self.getData(self.talkData)
      await self.getData(self.collectionData)
    },
    getData (itemData) {
      let self = this
      let pathArr = []
      for (let i = 0; i < itemData.length; i++) {
        pathArr.push(itemData[i].id)
      }
      axios.get(`/products?list=${pathArr.toString()}&pageSize=20`)
        .then((response) => {
          response.data.data.map(item1 => {
            itemData.map(item2 => {
              if (item1.id === item2.id) {
                return Object.assign(item2, item1)
              }
            })
          })
        })
        .then(() => {
          self.forceRerender()
        })
    },
    forceRerender () {
      this.renderComponent = false
      this.$nextTick(() => {
        this.renderComponent = true
      })
    },
    toTop (n) {
      this.isOpen = false
      jump(`${n}`, {
        duration: 500,
        offset: 0
      })
    },
    toTopM (n) {
      this.isOpen = false
      jump(`${n}`, {
        duration: 500,
        offset: -90
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.topNav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 3rem;
  display: flex;
  align-items: center;
  background-color: #444444;
}

.ham {
  position: relative;
  width: 2rem;
  height: 2rem;
  margin-left: 0.5rem;
  background: none;
  border: none;
  cursor: pointer;
  color: white;
}

.menuX {
  position: absolute;
  top: 2rem;
  right: 2rem;
  width: 2rem;
  height: 2rem;
  margin-left: 0.5rem;
  background: none;
  border: none;
  cursor: pointer;
  color: white;
}

.sideNav {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 101;
  background: rgb(68, 68, 68, .75);
  width: 250px;
  height: 100vh;
  overflow: hidden;
  color: white;
  /* hide the menu above the screen by default */
  transform: translateX(-100%);
  transition: transform 0.2s ease;
}

.showNav {
  transform: translateX(0);
}

.sideNav ul {
  width: 100%;
  height: 100%;
  list-style: none;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  padding-top: 5rem;
}

.sideNav ul li a {
  display: block;
  color: white;
  padding-bottom: 10px;
  margin-top: 1rem;
  // border-bottom: 2px solid black;
  text-decoration: none;
  font-family: 'Open Sans', sans-serif;
  font-size: 1.2rem;
  width: 100%;
  .icon {
    opacity: 0;
  }
}

.sideNav ul li a:hover, .sideNav ul li a:focus {
  // border-bottom: 2px solid white;
  .icon {
    opacity: 1;
  }
}

.main-text-color {
  color: #444444;
}
.text-shadow {
  text-shadow: 0px 2px #ffffff;
}
.box-shadow {
  box-shadow: 10px 10px 0px rgba(0, 0, 0, 0.25);
  border-radius: 24px;
  @media (max-width: 1440px) {
    box-shadow: 8px 8px 0px rgba(0, 0, 0, 0.25);
  }
}
.border-main {
  border-color: #D5DE6D;
}
.border-main2 {
  border-color: #6A8567;
}
.green-bg {
  background-color: #D5DE6D;
  background-size: 60px 60px;
  background-image: url('~@/assets/images/202301/Pattern.png');
}
.outer {
  position: relative;
  width: 100%;
  display: block;
  &:after {
    content: "";
    display: block;
    padding-Bottom: 100%;
  }
  .inner {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.banner-bg {
  background-color: #D5DE6D;
  background-size: 60px 60px;
  background-image: url('~@/assets/images/202301/Pattern.png');
  height: 500px;
  width: 100%;
  margin-top: -5.5%;
  z-index: 1;
  position: relative;
  @media (max-width: 768px) {
    margin-top: -25%;
    height: 150px;
  }
  @media (max-width: 640px) {
    margin-top: -25%;
    height: 100px;
  }
  &:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 200px;
    top: -100px;
    background-color: #D5DE6D;
    background-size: 60px 60px;
    background-image: url('~@/assets/images/202301/Pattern.png');
    border-radius: 50%;
  }
  .leafL {
    left: 12%;
    top: -54%;
    z-index: -1;
    img {
      width: 90%;
    }
    @media (max-width: 1024px) {
      left: 5%;
      top: -42%;
      width: 180px;
      img {
        width: 100%;
      }
    }
    @media (max-width: 768px) {
      left: 5%;
      top: -60%;
      width: 47px;
    }
    @media (max-width: 640px) {
      left: 5%;
      top: -100%;
      width: 47px;
    }
  }
  .leafR {
    right: 15%;
    top: -44%;
    z-index: -1;
    img {
      width: 90%;
    }
    @media (max-width: 1024px) {
      right: 2%;
      top: -40%;
      width: 180px;
      img {
        width: 100%;
      }
    }
    @media (max-width: 768px) {
      right: 5%;
      top: -60%;
      width: 47px;
    }
    @media (max-width: 640px) {
      right: 5%;
      top: -100%;
      width: 47px;
    }
  }
  .cloud {
    right: 20%;
    top: -75%;
    z-index: -1;
    @media (max-width: 1440px) {
      // top: -100%;
      // width: 70px;
      width: 100px;
    }
    @media (max-width: 1040px) {
      // top: -200%;
      width: 70px;
    }
    @media (max-width: 768px) {
      top: -180%;
      right: 12%;
      width: 70px;
    }
    @media (max-width: 425px) {
      top: -200%;
      right: 12%;
      width: 70px;
    }
  }
}
.section1 {
  position: relative;
  &:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 80px;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    background-color: #ffffff;
    z-index: 1;
    @media (max-width: 1440px) {
      background-color: transparent;
    }
  }
}
.magazine {
  position: relative;
  &:after{
    content: "";
    background-image: url('~@/assets/images/202301/BABO-5MG.png');
    background-repeat: no-repeat;
    position: absolute;
    width: 227px;
    height: 228px;
    z-index: 99;
    right: -5%;
    top: -10%;
    @media (max-width: 768px) {
      width: 84px;
      height: 84px;
      background-size: 84px;
      right: 0%;
      top: -3%;
    }
  }
}
.hiw {
  position: relative;
  &:after{
    content: "";
    background-image: url('~@/assets/images/202301/BABO-HIW.png');
    // background-size: 100px 100px;
    background-repeat: no-repeat;
    position: absolute;
    width: 227px;
    height: 228px;
    z-index: 99;
    right: -5%;
    top: -10%;
    @media (max-width: 768px) {
      width: 84px;
      height: 84px;
      background-size: 84px;
      right: 0%;
      top: -3%;
    }
  }
}
.collection {
  position: relative;
  &:after{
    content: "";
    background-image: url('~@/assets/images/202301/BABO-OLDMG.png');
    // background-size: 100px 100px;
    background-repeat: no-repeat;
    position: absolute;
    width: 227px;
    height: 228px;
    z-index: 99;
    right: -5%;
    top: -30%;
    @media (max-width: 1024px) {
      display: none;
    }
  }
}
</style>
